import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from '@emotion/react'
import { appTheme } from './styles/AppTheme'
import { CssBaseline } from '@mui/material'
import App from './App'
import { ToastContainer } from 'react-toastify'
import { MaintenanceViewProvider } from './context/MaintenanceViewContext';
import { DataViewsProvider } from './context/DataViewsContext';

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <DataViewsProvider>
        <MaintenanceViewProvider>
          <App />
          <CssBaseline />
          <ToastContainer />
        </MaintenanceViewProvider>
      </DataViewsProvider>
    </ThemeProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
